import React, { useState } from 'react';
import { 
  MagnifyingGlassIcon,
  ChevronDownIcon,
  ArrowRightIcon
} from '@heroicons/react/24/outline';

const Home = () => {
  const [searchType, setSearchType] = useState('Location');
  const [searchInput, setSearchInput] = useState('');

  return (
    <div className="min-h-screen">
        {/* Desktop View - Hidden on Mobile */}
      <div className="hidden md:block min-h-screen relative" style={{
          backgroundImage: 'url(images/bg.png)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}>
          {/* Overlay with gradient fade */}
          <div className="absolute inset-0" style={{
            background: 'linear-gradient(to right, rgba(32, 71, 111, 0.8) 0%, rgba(32, 71, 111, 0.8) 50%, rgba(191, 202, 213, 0.8) 100%)'
          }}></div>
          
          {/* Main Content */}
          <div className="max-w-[65rem] mx-auto relative z-10 flex items-center justify-between px-8 py-12 min-h-screen">
            {/* Left Side - Main Heading and Content */}
            <div className="flex-1 max-w-2xl">
              <h1 className="text-[3.35rem] font-light text-[#BFCAE2] mb-8 leading-tight md:mt-3" style={{fontFamily: 'Source Serif Pro'}}>
                The Federal Courts
                <br />
                <span className="block">of the United States</span>
              </h1>
              
              <p className="text-[16px] text-blue-100 mb-8 leading-relaxed max-w-xl" style={{lineHeight: '1.5'}}>
                The U.S. Courts were created under Article III of the Constitution to 
                administer justice fairly and impartially, within the jurisdiction 
                established by the Constitution and Congress. This site will help you 
                learn more about the Judicial Branch and its work.
              </p>

              <button className="inline-flex items-center px-6 py-3 bg-[#efd388] hover:bg-[#f9fafb] text-black font-medium  transition-colors" style={{borderRadius: '1.375rem'}}>
                <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2L2 7v2h20V7L12 2zM4 11v8h2v-8H4zm4 0v8h2v-8H8zm4 0v8h2v-8h-2zm4 0v8h2v-8h-2zm4 0v8h2v-8h-2zM2 21h20v2H2v-2z"/>
                </svg>
                About the Federal Courts
              </button>
            </div>

            {/* Right Side - Search Cards */}
            <div className="flex-1 max-w-md ml-12 space-y-6">
              {/* Find a Federal Court Card */}
              <div 
                className="bg-white shadow-lg p-6 mt-2"
                style={{
                  height: '313.33px',
                  width: '363.44px',
                  borderRadius: '1.5rem'
                }}
              >
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                  Find a Federal Court
                </h2>
                <p className="text-gray-600 mb-6">
                  Find a federal court by location or court name.
                </p>

                {/* Search Type Toggle */}
                <div className="flex mb-6 " style={{height:'30px',}}>
                  <button
                    className={`px-4 py-0 font-medium transition-colors ${
                      searchType === 'Location' 
                        ? 'bg-[#0057a3] text-white rounded-l-full' 
                        : 'bg-gray-200 text-gray-700 hover:bg-gray-300 rounded-l-full'
                    }`}
                    onClick={() => setSearchType('Location')}
                  >
                    Location
                    <ChevronDownIcon className="w-4 h-4 ml-1 inline" />
                  </button>
                  <button
                    className={`px-4 py-0 font-medium transition-colors ${
                      searchType === 'Court name' 
                        ? 'bg-[#0057a3] text-white rounded-r-full' 
                        : 'bg-gray-200 text-gray-700 hover:bg-gray-300 rounded-r-full'
                    }`}
                    onClick={() => setSearchType('Court name')}
                  >
                    Court name
                  </button>
                </div>

                {/* Search Input */}
                <div className="relative mb-4">
                  <input
                    type="text"
                    placeholder=""
                    value={searchInput}
                    onChange={(e) => setSearchInput(e.target.value)}
                    className="w-full px-4 py-3 pr-12 border border-gray-300 rounded-full focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-gray-50"
                  />
                  <button className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600">
                    <MagnifyingGlassIcon className="w-5 h-5" />
                  </button>
                </div>
                <p className="text-sm text-gray-500 mt-2">
                  Search by address, city, state, or ZIP code
                </p>
              </div>

              {/* Find a Form Card */}
              <div 
                className="bg-white shadow-lg p-6"
                style={{
                  width: '363.33px',
                  height: '233.4px',
                  borderRadius: '1.5rem'
                }}
              >
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                  Find a Form
                </h2>
                <p className="text-gray-600 mb-6">
                  Search for national federal court forms by keyword, number or category.
                </p>

                <button className="inline-flex items-center px-6 py-3 bg-[#0057a3] hover:bg-blue-700 text-white font-medium rounded-full transition-colors">
                  Search for a form
                  <ArrowRightIcon className="w-5 h-5 ml-2" />
                </button>
              </div>
            </div>
          </div>
      </div>

      {/* Mobile View - Hidden on Desktop */}
      <div className="md:hidden min-h-screen">
        {/* Hero Section */}
        <div className="relative" style={{
          backgroundImage: 'url(images/bg2.png)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          height: '75vh'
        }}>
          {/* Overlay */}
          <div className="absolute inset-0" style={{
            background: 'linear-gradient(to bottom, rgba(32, 71, 111, 0.8), rgba(32, 71, 111, 0.9))'
          }}></div>
          
          {/* Hero Content */}
          <div className="relative z-10 px-6 pt-12 pb-20">
            <h1 className="text-3xl font-light text-white mb-6 leading-tight" style={{fontFamily: 'Source Serif Pro'}}>
              The Federal Courts of the United States
            </h1>
            
            <p className="text-sm text-blue-100 mb-8 leading-relaxed">
              The U.S. Courts were created under Article III of the Constitution to administer justice fairly and impartially, within the jurisdiction established by the Constitution and Congress. This site will help you learn more about the Judicial Branch and its work.
            </p>

            <button className="inline-flex items-center px-6 py-3 bg-[#efd388] hover:bg-[#f9fafb] text-black font-medium transition-colors" style={{borderRadius: '1.375rem'}}>
              <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2L2 7v2h20V7L12 2zM4 11v8h2v-8H4zm4 0v8h2v-8H8zm4 0v8h2v-8h-2zm4 0v8h2v-8h-2zm4 0v8h2v-8h-2zM2 21h20v2H2v-2z"/>
              </svg>
              About the Federal Courts
            </button>
          </div>
        </div>

        {/* Cards Section with Overlap */}
        <div className="relative -mt-16 px-6 pb-8 space-y-6">
          {/* Find a Federal Court Card */}
          <div className="bg-white shadow-lg p-6 rounded-3xl">
            <h2 className="text-xl font-semibold text-gray-900 mb-3">
              Find a Federal Court
            </h2>
            <p className="text-gray-600 mb-6 text-sm">
              Find a federal court by location or court name.
            </p>

            {/* Search Type Toggle */}
            <div className="flex mb-6">
              <button
                className={`px-4 py-2 text-sm font-medium transition-colors ${
                  searchType === 'Location' 
                    ? 'bg-[#0057a3] text-white rounded-l-full' 
                    : 'bg-gray-200 text-gray-700 hover:bg-gray-300 rounded-l-full'
                }`}
                onClick={() => setSearchType('Location')}
              >
                Location
                <ChevronDownIcon className="w-3 h-3 ml-1 inline" />
              </button>
              <button
                className={`px-4 py-2 text-sm font-medium transition-colors ${
                  searchType === 'Court name' 
                    ? 'bg-[#0057a3] text-white rounded-r-full' 
                    : 'bg-gray-200 text-gray-700 hover:bg-gray-300 rounded-r-full'
                }`}
                onClick={() => setSearchType('Court name')}
              >
                Court name
              </button>
            </div>

            {/* Search Input */}
            <div className="relative mb-4">
              <input
                type="text"
                placeholder=""
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
                className="w-full px-4 py-3 pr-12 border border-gray-300 rounded-full focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-gray-50"
              />
              <button className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600">
                <MagnifyingGlassIcon className="w-5 h-5" />
              </button>
            </div>
            <p className="text-xs text-gray-500">
              Search by address, city, state, or ZIP code
            </p>
          </div>

          {/* Find a Form Card */}
          <div className="bg-white shadow-lg p-6 rounded-3xl">
            <h2 className="text-xl font-semibold text-gray-900 mb-3">
              Find a Form
            </h2>
            <p className="text-gray-600 mb-6 text-sm">
              Search for national federal court forms by keyword, number or category.
            </p>

            <button className="inline-flex items-center px-6 py-3 bg-[#0057a3] hover:bg-blue-700 text-white font-medium rounded-full transition-colors">
              Search for a form
              <ArrowRightIcon className="w-4 h-4 ml-2" />
            </button>
          </div>
        </div>
      </div>


      
      
      {/* Quick Links Section */}
      <div className="bg-gray-50 py-16">
        <div className="max-w-[65rem] mx-auto px-8">
          <h2 className="text-3xl font-semibold text-gray-900 mb-8">Quick Links</h2>
          
          {/* Desktop View - Hidden on Mobile */}
          <div className="hidden md:grid grid-cols-6 gap-6 text-[17px]">
            <div className="bg-blue-50 border-2 border-[#0057a3] rounded-2xl p-6 text-center hover:bg-blue-100 transition-colors cursor-pointer">
              <div className="flex justify-center mb-4">
                
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-8 h-8 text-[#0057a3] size-6">
                  <path d="M19.906 9c.382 0 .749.057 1.094.162V9a3 3 0 0 0-3-3h-3.879a.75.75 0 0 1-.53-.22L11.47 3.66A2.25 2.25 0 0 0 9.879 3H6a3 3 0 0 0-3 3v3.162A3.756 3.756 0 0 1 4.094 9h15.812ZM4.094 10.5a2.25 2.25 0 0 0-2.227 2.568l.857 6A2.25 2.25 0 0 0 4.951 21H19.05a2.25 2.25 0 0 0 2.227-1.932l.857-6a2.25 2.25 0 0 0-2.227-2.568H4.094Z" />
                </svg>

              </div>
              <h3 className="font-medium text-gray-900 text-sm">Find a Case</h3>
              <p className="text-xs text-gray-600 mt-1">(PACER)</p>
            </div>

            <div className="bg-blue-50 border-2 border-[#0057a3] rounded-2xl p-6 text-center hover:bg-blue-100 transition-colors cursor-pointer">
              <div className="flex justify-center mb-4">
                <svg className="w-8 h-8 text-[#0057a3]" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"/>
                </svg>
              </div>
              <h3 className="font-medium text-gray-900 text-sm">About</h3>
              <p className="text-xs text-gray-600 mt-1">Bankruptcy</p>
            </div>

            <div className="bg-blue-50 border-2 border-[#0057a3] rounded-2xl p-6 text-center hover:bg-blue-100 transition-colors cursor-pointer">
              <div className="flex justify-center mb-4">

                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-8 h-8 text-[#0057a3] size-6">
                  <path fillRule="evenodd" d="M8.25 6.75a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0ZM15.75 9.75a3 3 0 1 1 6 0 3 3 0 0 1-6 0ZM2.25 9.75a3 3 0 1 1 6 0 3 3 0 0 1-6 0ZM6.31 15.117A6.745 6.745 0 0 1 12 12a6.745 6.745 0 0 1 6.709 7.498.75.75 0 0 1-.372.568A12.696 12.696 0 0 1 12 21.75c-2.305 0-4.47-.612-6.337-1.684a.75.75 0 0 1-.372-.568 6.787 6.787 0 0 1 1.019-4.38Z" clipRule="evenodd" />
                  <path d="M5.082 14.254a8.287 8.287 0 0 0-1.308 5.135 9.687 9.687 0 0 1-1.764-.44l-.115-.04a.563.563 0 0 1-.373-.487l-.01-.121a3.75 3.75 0 0 1 3.57-4.047ZM20.226 19.389a8.287 8.287 0 0 0-1.308-5.135 3.75 3.75 0 0 1 3.57 4.047l-.01.121a.563.563 0 0 1-.373.486l-.115.04c-.567.2-1.156.349-1.764.441Z" />
                </svg>

              </div>
              <h3 className="font-medium text-gray-900 text-sm">Jury Service</h3>
            </div>

            <div className="bg-blue-50 border-2 border-[#0057a3] rounded-2xl p-6 text-center hover:bg-blue-100 transition-colors cursor-pointer">
              <div className="flex justify-center mb-4">
                <svg className="w-8 h-8 text-[#0057a3]" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-1 16H9V7h9v14z"/>
                </svg>
              </div>
              <h3 className="font-medium text-gray-900 text-sm">Educational</h3>
              <p className="text-xs text-gray-600 mt-1">Resources</p>
            </div>

            <div className="bg-blue-50 border-2 border-[#0057a3] rounded-2xl p-6 text-center hover:bg-blue-100 transition-colors cursor-pointer">
              <div className="flex justify-center mb-4">
                <svg className="w-8 h-8 text-[#0057a3]" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.94-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/>
                </svg>
              </div>
              <h3 className="font-medium text-gray-900 text-sm">Judicial</h3>
              <p className="text-xs text-gray-600 mt-1">Vacancies</p>
            </div>

            <div className="bg-blue-50 border-2 border-[#0057a3] rounded-2xl p-6 text-center hover:bg-blue-100 transition-colors cursor-pointer">
              <div className="flex justify-center mb-4">
                <svg className="w-8 h-8 text-[#0057a3]" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20 3H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h3l-1 1v1h12v-1l-1-1h3c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 13H4V5h16v11z"/>
                </svg>
              </div>
              <h3 className="font-medium text-gray-900 text-sm">Search Jobs</h3>
            </div>
          </div>

          {/* Mobile View - Hidden on Desktop */}
          <div className="md:hidden grid grid-cols-2 gap-4">
            <div className="bg-blue-50 border-2 border-[#0057a3] rounded-2xl p-6 text-center hover:bg-blue-100 transition-colors cursor-pointer">
              <div className="flex justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-8 h-8 text-[#0057a3] size-6">
                  <path d="M19.906 9c.382 0 .749.057 1.094.162V9a3 3 0 0 0-3-3h-3.879a.75.75 0 0 1-.53-.22L11.47 3.66A2.25 2.25 0 0 0 9.879 3H6a3 3 0 0 0-3 3v3.162A3.756 3.756 0 0 1 4.094 9h15.812ZM4.094 10.5a2.25 2.25 0 0 0-2.227 2.568l.857 6A2.25 2.25 0 0 0 4.951 21H19.05a2.25 2.25 0 0 0 2.227-1.932l.857-6a2.25 2.25 0 0 0-2.227-2.568H4.094Z" />
                </svg>
              </div>
              <h3 className="font-medium text-gray-900 text-sm">Find a Case (PACER)</h3>
            </div>

            <div className="bg-blue-50 border-2 border-[#0057a3] rounded-2xl p-6 text-center hover:bg-blue-100 transition-colors cursor-pointer">
              <div className="flex justify-center mb-4">
                <svg className="w-8 h-8 text-[#0057a3]" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"/>
                </svg>
              </div>
              <h3 className="font-medium text-gray-900 text-sm">About Bankruptcy</h3>
            </div>

            <div className="bg-blue-50 border-2 border-[#0057a3] rounded-2xl p-6 text-center hover:bg-blue-100 transition-colors cursor-pointer">
              <div className="flex justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-8 h-8 text-[#0057a3] size-6">
                  <path fillRule="evenodd" d="M8.25 6.75a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0ZM15.75 9.75a3 3 0 1 1 6 0 3 3 0 0 1-6 0ZM2.25 9.75a3 3 0 1 1 6 0 3 3 0 0 1-6 0ZM6.31 15.117A6.745 6.745 0 0 1 12 12a6.745 6.745 0 0 1 6.709 7.498.75.75 0 0 1-.372.568A12.696 12.696 0 0 1 12 21.75c-2.305 0-4.47-.612-6.337-1.684a.75.75 0 0 1-.372-.568 6.787 6.787 0 0 1 1.019-4.38Z" clipRule="evenodd" />
                  <path d="M5.082 14.254a8.287 8.287 0 0 0-1.308 5.135 9.687 9.687 0 0 1-1.764-.44l-.115-.04a.563.563 0 0 1-.373-.487l-.01-.121a3.75 3.75 0 0 1 3.57-4.047ZM20.226 19.389a8.287 8.287 0 0 0-1.308-5.135 3.75 3.75 0 0 1 3.57 4.047l-.01.121a.563.563 0 0 1-.373.486l-.115.04c-.567.2-1.156.349-1.764.441Z" />
                </svg>
              </div>
              <h3 className="font-medium text-gray-900 text-sm">Jury Service</h3>
            </div>

            <div className="bg-blue-50 border-2 border-[#0057a3] rounded-2xl p-6 text-center hover:bg-blue-100 transition-colors cursor-pointer">
              <div className="flex justify-center mb-4">
                <svg className="w-8 h-8 text-[#0057a3]" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-1 16H9V7h9v14z"/>
                </svg>
              </div>
              <h3 className="font-medium text-gray-900 text-sm">Educational Resources</h3>
            </div>

            <div className="bg-blue-50 border-2 border-[#0057a3] rounded-2xl p-6 text-center hover:bg-blue-100 transition-colors cursor-pointer">
              <div className="flex justify-center mb-4">
                <svg className="w-8 h-8 text-[#0057a3]" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.94-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/>
                </svg>
              </div>
              <h3 className="font-medium text-gray-900 text-sm">Judicial Vacancies</h3>
            </div>

            <div className="bg-blue-50 border-2 border-[#0057a3] rounded-2xl p-6 text-center hover:bg-blue-100 transition-colors cursor-pointer">
              <div className="flex justify-center mb-4">
                <svg className="w-8 h-8 text-[#0057a3]" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20 3H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h3l-1 1v1h12v-1l-1-1h3c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 13H4V5h16v11z"/>
                </svg>
              </div>
              <h3 className="font-medium text-gray-900 text-sm">Search Jobs</h3>
            </div>
          </div>
        </div>
      </div>




      {/* Explore the Federal Courts Section */}
      <div className="bg-[#f9fafb] py-16">
        <div className="max-w-[65rem] mx-auto px-8">
          {/* Desktop View - Hidden on Mobile */}
          <div className="hidden md:flex items-start gap-8">
            {/* Video Section */}
            <div className="flex-1">
              <div className="relative bg-gray-900 rounded-2xl overflow-hidden" style={{aspectRatio: '16/9'}}>
                <iframe
                  className="w-full h-full"
                  src="https://www.youtube.com/embed/fVrb5mHFyvg?feature=oembed"
                  title="Court Shorts: Separation of Powers"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            </div>

            {/* Links Section */}
            <div className="flex-1 max-w-md">
              <h2 className="text-3xl font-semibold text-gray-900 mb-8"  style={{fontFamily: 'Source Serif Pro'}}>Explore the Federal Courts</h2>
              
              <div className="space-y-4">
                <a href="#" className="flex items-center text-blue-600 hover:text-blue-800 transition-colors group">
                  <svg className="w-6 h-6 mr-3 text-gray-800" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2L2 7v2h20V7L12 2zM4 11v8h2v-8H4zm4 0v8h2v-8H8zm4 0v8h2v-8h-2zm4 0v8h2v-8h-2zm4 0v8h2v-8h-2zM2 21h20v2H2v-2z"/>
                  </svg>
                  <span className="text-lg underline group-hover:no-underline text-[#0057a3]">Court Role and Structure</span>
                </a>

                <a href="#" className="flex items-center text-blue-600 hover:text-blue-800 transition-colors group">
                  <svg className="w-6 h-6 mr-3 text-gray-800" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm9 7h-6v13h-2v-6h-2v6H9V9H3V7h18v2z"/>
                  </svg>
                  <span className="text-lg underline group-hover:no-underline text-[#0057a3]">About Federal Judges</span>
                </a>

                <a href="#" className="flex items-center text-blue-600 hover:text-blue-800 transition-colors group">
                  <svg className="w-6 h-6 mr-3 text-gray-800" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M16 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zm4 18v-6h2.5l-2.54-7.63A1.5 1.5 0 0 0 18.54 8H16c-.8 0-1.54.37-2.01 1l-2.7 3.6L8.5 11h-5C2.67 11 2 11.67 2 12.5S2.67 14 3.5 14H7l3.5 1.4 2.9-3.87.85 2.55V20h6z"/>
                  </svg>
                  <span className="text-lg underline group-hover:no-underline text-[#0057a3]">Probation and Pretrial Services</span>
                </a>

                <a href="#" className="flex items-center text-blue-600 hover:text-blue-800 transition-colors group">
                  <svg className="w-6 h-6 mr-3 text-gray-800" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"/>
                  </svg>
                  <span className="text-lg underline group-hover:no-underline text-[#0057a3]">Defender Services</span>
                </a>
              </div>
            </div>
          </div>

          {/* Mobile View - Hidden on Desktop */}
          <div className="md:hidden">
            {/* Video Section */}
            <div className="mb-8">
              <div className="relative bg-gray-900 rounded-2xl overflow-hidden" style={{aspectRatio: '16/9'}}>
                <iframe
                  className="w-full h-full"
                  src="https://www.youtube.com/embed/fVrb5mHFyvg?feature=oembed"
                  title="Court Shorts: Separation of Powers"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            </div>

            {/* Links Section */}
            <div>
              <h2 className="text-2xl font-semibold text-gray-900 mb-6" style={{fontFamily: 'Source Serif Pro'}}>Explore the Federal Courts</h2>
              
              <div className="space-y-4">
                <a href="#" className="flex items-center text-blue-600 hover:text-blue-800 transition-colors group">
                  <svg className="w-5 h-5 mr-3 text-gray-800" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2L2 7v2h20V7L12 2zM4 11v8h2v-8H4zm4 0v8h2v-8H8zm4 0v8h2v-8h-2zm4 0v8h2v-8h-2zm4 0v8h2v-8h-2zM2 21h20v2H2v-2z"/>
                  </svg>
                  <span className="text-base underline group-hover:no-underline text-[#0057a3]">Court Role and Structure</span>
                </a>

                <a href="#" className="flex items-center text-blue-600 hover:text-blue-800 transition-colors group">
                  <svg className="w-5 h-5 mr-3 text-gray-800" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm9 7h-6v13h-2v-6h-2v6H9V9H3V7h18v2z"/>
                  </svg>
                  <span className="text-base underline group-hover:no-underline text-[#0057a3]">About Federal Judges</span>
                </a>

                <a href="#" className="flex items-center text-blue-600 hover:text-blue-800 transition-colors group">
                  <svg className="w-5 h-5 mr-3 text-gray-800" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M16 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zm4 18v-6h2.5l-2.54-7.63A1.5 1.5 0 0 0 18.54 8H16c-.8 0-1.54.37-2.01 1l-2.7 3.6L8.5 11h-5C2.67 11 2 11.67 2 12.5S2.67 14 3.5 14H7l3.5 1.4 2.9-3.87.85 2.55V20h6z"/>
                  </svg>
                  <span className="text-base underline group-hover:no-underline text-[#0057a3]">Probation and Pretrial Services</span>
                </a>

                <a href="#" className="flex items-center text-blue-600 hover:text-blue-800 transition-colors group">
                  <svg className="w-5 h-5 mr-3 text-gray-800" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"/>
                  </svg>
                  <span className="text-base underline group-hover:no-underline text-[#0057a3]">Defender Services</span>
                </a>
              </div>

              {/* Bottom Border */}
              <div className="mt-8 border-b border-gray-300"></div>
            </div>
          </div>
        </div>
      </div>





        {/* Judiciary News Section */}
        <div className="bg-[#f9fafb] py-16">
          <div className="max-w-[65rem] mx-auto px-8">
            {/* Desktop View - Hidden on Mobile */}
            <div className="hidden md:block">
              <div className="border-t border-gray-300 pt-8">
                <div className="flex gap-12">
                  {/* News List */}
                  <div className="flex-1">
                    <h2 className="text-3xl font-semibold text-gray-900 mb-8" style={{fontFamily: 'Source Serif Pro'}}>Judiciary News</h2>
                    
                    <div className="space-y-8">
                      <div className="border-b border-gray-300 pb-6">
                        <p className="text-gray-600 text-sm mb-2">December 31, 2024</p>
                        <a href="#" className="text-[#0057a3] hover:text-blue-800 underline text-lg">
                          Chief Justice Roberts Issues 2024 Year-End Report
                        </a>
                      </div>

                      <div className="border-b border-gray-300 pb-6">
                        <p className="text-gray-600 text-sm mb-2">December 24, 2024</p>
                        <a href="#" className="text-[#0057a3] hover:text-blue-800 underline text-lg">
                          Statement of Judge Robert J. Conrad, Jr., Director of the AO, Regarding Veto of the JUDGES Act
                        </a>
                      </div>

                      <div className="border-b border-gray-300 pb-6">
                        <p className="text-gray-600 text-sm mb-2">December 19, 2024</p>
                        <a href="#" className="text-[#0057a3] hover:text-blue-800 underline text-lg">
                          New Courthouse Learning Center Teaches Minnesota Students About Judiciary
                        </a>
                      </div>

                      <div className="border-b border-gray-300 pb-6">
                        <p className="text-gray-600 text-sm mb-2">December 12, 2024</p>
                        <a href="#" className="text-[#0057a3] hover:text-blue-800 underline text-lg">
                          Students See Their Future in the Judiciary as They Celebrate Bill of Rights Day
                        </a>
                      </div>
                    </div>

                    <div className="mt-8">
                      <a href="#" className="text-[#0057a3] hover:text-blue-800 underline text-base">
                        See all news stories →
                      </a>
                    </div>
                  </div>

                  {/* Featured Article Card */}
                  <div className="w-80 flex-shrink-0">
                    <div className="bg-white border border-gray-200  overflow-hidden shadow-md" style={{borderRadius: '16px'}}>
                      <img 
                        src="images/second.png" 
                        alt="New Courthouse Learning Center" 
                        className="w-full h-48 object-cover"
                      />
                      <div className="p-6">
                        <h3 className="text-xl font-semibold text-gray-900 mb-4">
                          New Courthouse Learning Center Teaches Students About Judiciary
                        </h3>
                        <p className="text-gray-600 text-sm mb-6 leading-relaxed">
                          The federal district court in Minnesota is preparing today's students to be the leaders of 
                          tomorrow through a new courthouse learning center in St. Paul, and is one of a growing 
                          number of civics education centers, museums, and exhibits in federal court buildings 
                          across the country.
                        </p>
                        <button className="bg-[#0057a3] hover:bg-blue-700 text-white px-6 py-2 rounded-full text-sm font-medium transition-colors">
                          Read article
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Mobile View - Hidden on Desktop */}
            <div className="md:hidden">
              <div className="border-t border-gray-300 pt-6">
                <h2 className="text-2xl font-semibold text-gray-900 mb-6" style={{fontFamily: 'Source Serif Pro'}}>Judiciary News</h2>
                
                <div className="space-y-6">
                  <div className="border-b border-gray-300 pb-4">
                    <p className="text-gray-600 text-sm mb-2">December 31, 2024</p>
                    <a href="#" className="text-[#0057a3] hover:text-blue-800 underline text-base">
                      Chief Justice Roberts Issues 2024 Year-End Report
                    </a>
                  </div>

                  <div className="border-b border-gray-300 pb-4">
                    <p className="text-gray-600 text-sm mb-2">December 24, 2024</p>
                    <a href="#" className="text-[#0057a3] hover:text-blue-800 underline text-base">
                      Statement of Judge Robert J. Conrad, Jr., Director of the AO, Regarding Veto of the JUDGES Act
                    </a>
                  </div>

                  <div className="border-b border-gray-300 pb-4">
                    <p className="text-gray-600 text-sm mb-2">December 19, 2024</p>
                    <a href="#" className="text-[#0057a3] hover:text-blue-800 underline text-base">
                      New Courthouse Learning Center Teaches Minnesota Students About Judiciary
                    </a>
                  </div>

                  <div className="border-b border-gray-300 pb-4">
                    <p className="text-gray-600 text-sm mb-2">December 12, 2024</p>
                    <a href="#" className="text-[#0057a3] hover:text-blue-800 underline text-base">
                      Students See Their Future in the Judiciary as They Celebrate Bill of Rights Day
                    </a>
                  </div>
                </div>

                <div className="mt-6 mb-8">
                  <a href="#" className="text-[#0057a3] hover:text-blue-800 underline text-base">
                    See all news stories →
                  </a>
                </div>

                {/* Featured Article Card */}
                <div className="bg-white border border-gray-200  overflow-hidden shadow-md" style={{borderRadius: '16px'}}>
                  <img 
                    src="images/second.png" 
                    alt="New Courthouse Learning Center" 
                    className="w-full h-48 object-cover"
                  />
                  <div className="p-6">
                    <h3 className="text-xl font-semibold text-gray-900 mb-4">
                      New Courthouse Learning Center Teaches Students About Judiciary
                    </h3>
                    <p className="text-gray-600 text-sm mb-6 leading-relaxed">
                      The federal district court in Minnesota is preparing today's students to be the leaders of 
                      tomorrow through a new courthouse learning center in St. Paul, and is one of a growing 
                      number of civics education centers, museums, and exhibits in federal court buildings 
                      across the country.
                    </p>
                    <button className="bg-[#0057a3] hover:bg-blue-700 text-white px-6 py-2 rounded-full text-sm font-medium transition-colors">
                      Read article
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>



        {/* Three Cards Section */}
        <div className="bg-gray-50 py-16">
          <div className="max-w-[65rem] mx-auto px-8">
            <div className="border-t border-gray-300 pt-16">
              {/* Desktop View - Hidden on Mobile */}
              <div className="hidden md:grid grid-cols-3 gap-8">
                {/* Rules and Forms Amendments */}
                <div className="bg-white rounded-3xl shadow-lg p-8 h-full flex flex-col">
                  <h3 className="text-2xl font-semibold text-gray-900 mb-6">
                    Rules and Forms Amendments
                  </h3>
                  <p className="text-gray-600 mb-8 flex-grow leading-relaxed">
                    Learn about amendments to the Federal Rules of Practice & Procedure and forms, which became effective Dec. 1, 2024.
                  </p>
                  <button className="bg-[#0057a3] hover:bg-blue-700 text-white px-6 py-3 rounded-full font-medium transition-colors self-start">
                    Read the changes
                  </button>
                </div>

                {/* New Caseload Statistics */}
                <div className="bg-white rounded-3xl shadow-lg p-8 h-full flex flex-col">
                  <h3 className="text-2xl font-semibold text-gray-900 mb-6">
                    New Caseload Statistics
                  </h3>
                  <p className="text-gray-600 mb-8 flex-grow leading-relaxed">
                    Review <em>Federal Judicial Caseload Statistics</em> to find federal court data for the 12-month period ending March 31, 2024.
                  </p>
                  <button className="bg-[#0057a3] hover:bg-blue-700 text-white px-6 py-3 rounded-full font-medium transition-colors self-start">
                    Read the report
                  </button>
                </div>

                {/* 2023 Director's Annual Report */}
                <div className="bg-white rounded-3xl shadow-lg p-8 h-full flex flex-col">
                  <h3 className="text-2xl font-semibold text-gray-900 mb-6">
                    2023 Director's Annual Report
                  </h3>
                  <p className="text-gray-600 mb-8 flex-grow leading-relaxed">
                    Read about major activities of the federal Judiciary and the Administrative Office of the U.S. Courts in 2023.
                  </p>
                  <button className="bg-[#0057a3] hover:bg-blue-700 text-white px-6 py-3 rounded-full font-medium transition-colors self-start">
                    Read the report
                  </button>
                </div>
              </div>

              {/* Mobile View - Hidden on Desktop */}
              <div className="md:hidden space-y-6">
                {/* Rules and Forms Amendments */}
                <div className="bg-white rounded-3xl shadow-lg p-6">
                  <h3 className="text-xl font-semibold text-gray-900 mb-4">
                    Rules and Forms Amendments
                  </h3>
                  <p className="text-gray-600 mb-6 text-sm leading-relaxed">
                    Learn about amendments to the Federal Rules of Practice & Procedure and forms, which became effective Dec. 1, 2024.
                  </p>
                  <button className="bg-[#0057a3] hover:bg-blue-700 text-white px-6 py-2 rounded-full text-sm font-medium transition-colors">
                    Read the changes
                  </button>
                </div>

                {/* New Caseload Statistics */}
                <div className="bg-white rounded-3xl shadow-lg p-6">
                  <h3 className="text-xl font-semibold text-gray-900 mb-4">
                    New Caseload Statistics
                  </h3>
                  <p className="text-gray-600 mb-6 text-sm leading-relaxed">
                    Review <em>Federal Judicial Caseload Statistics</em> to find federal court data for the 12-month period ending March 31, 2024.
                  </p>
                  <button className="bg-[#0057a3] hover:bg-blue-700 text-white px-6 py-2 rounded-full text-sm font-medium transition-colors">
                    Read the report
                  </button>
                </div>

                {/* 2023 Director's Annual Report */}
                <div className="bg-white rounded-3xl shadow-lg p-6">
                  <h3 className="text-xl font-semibold text-gray-900 mb-4">
                    2023 Director's Annual Report
                  </h3>
                  <p className="text-gray-600 mb-6 text-sm leading-relaxed">
                    Read about major activities of the federal Judiciary and the Administrative Office of the U.S. Courts in 2023.
                  </p>
                  <button className="bg-[#0057a3] hover:bg-blue-700 text-white px-6 py-2 rounded-full text-sm font-medium transition-colors">
                    Read the report
                  </button>
                </div>
              </div>

              {/* Return to top button */}
              <div className="flex justify-end mt-12">
                <button className="border border-[#0057a3] text-[#0057a3] hover:bg-blue-50 px-6 py-2 rounded-full font-medium transition-colors flex items-center">
                  Return to top
                  <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>


    </div>
  );
};

export default Home;